module.exports = __webpack_public_path__ + "img/cover.b060305e.png";